// extracted by mini-css-extract-plugin
module.exports = {"ProcessOptimizationAdvisor":"ProcessOptimizationAdvisor_ProcessOptimizationAdvisor__2X8sv"};